import Axios from 'axios';

const state = {
  loading: false,
  error: null,
  recruitersTable: null,
  sorting: {
    numberColumn: null,
    order: 'desc'
  }
};

const isNotNull = v => v !== undefined && v !== null;

const actions = {
  async fetch({ commit, dispatch }, params) {
    commit('fetch');

    const sorting = state.sorting;

    if (isNotNull(sorting.numberColumn)) {
      params['sort_by'] = sorting.numberColumn;
      params['sort_order'] = sorting.order;
    }

    // fetchRecruitersTable (params) {
    //   return new Promise((resolve, reject) => {
    //     Axios.get('/1.0/analytics/user-response-summary-table', { params })
    //       .then(response => resolve(parseResponse(response).data[0]))
    //       .catch(err => reject(handleError(err)))
    //   })
    // },

    return await Axios.get('/1.0/analytics/user-response-summary-table', { params })
      .then(response => {
        console.log(response);
        commit('fetchSuccess', response.data.data[0]);
      })
      .catch(err => {
        dispatch('global/setError', err, { root: true });
        commit('fetchFailure', err);
      });
  }
};

const mutations = {
  fetch(state) {
    state.loading = true;
  },

  fetchSuccess(state, res) {
    state.recruitersTable = res;
    state.loading = false;
  },

  fetchFailure(state, err) {
    state.error = err;
    state.loading = false;
  },

  updateSorting(state, data) {
    Object.assign(state.sorting, data);
  }
};

const getters = {
  recruitersTable: state => state.recruitersTable,
  sorting: state => state.sorting,
  loading: state => state.loading
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
